// Apre la live chat Smartsupp. È l'unico canale di supporto del sito:
// niente più indirizzi email di contatto sparsi tra footer/privacy/tos.
export function openSupportChat() {
  if (typeof window !== "undefined" && typeof window.smartsupp === "function") {
    window.smartsupp("chat:open");
  }
}
